const tours = {
  tour: "Περιοδεία", // translated
  tours: "Περιηγήσεις", // translated
  addOn: "Πρόσθετο", // translated
  addOns: "Προσθήκες", // translated
  availableEscapes: "Διαθέσιμες αποδράσεις", // translated
  availableExperiences: "Διαθέσιμες Εμπειρίες", // translated
  getRequest: "Λήψη αιτήματος", // translated
  sendRequest: "Στείλε αίτημα", // translated
  selectRoom: "Επιλέξτε ένα δωμάτιο", // translated
};


export default tours;
